export default __webpack_public_path__ + "static/media/0.e33a95c7.png";